// eslint-disable-next-line import/no-unresolved
import $ from 'jquery';

import RecipeNotices from '../recipe/notices.js';

class Publish {
	constructor() {
		// Create new metabox
		this.createMetabox();
	}

	createMetabox() {
		// Render metabox
		$( '#uo-automator-publish-metabox' ).html( `
			<uap-builder-publish></uap-builder-publish>
		` );
	}
}

export default Publish;
